import { css } from '@emotion/css'
import { minScreen } from 'utils/mediaQueries'

export const title = css`
  margin-bottom: 16px;
  text-align: center;
  ${minScreen('md')} {
    margin-bottom: 11px;
  }
`;